import React from "react";

import { IProductTemplateTableEditor } from "components/ComponentType";
import { InputNumber, InputNumberValueChangeEvent } from "primereact/inputnumber";
import { InputSwitchChangeEvent } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { MultiSelectChangeEvent } from "primereact/multiselect";
import { T } from "services/lang/LanguageService";

type ProductTemplateConfigProps = {
  currentConfig: IProductTemplateTableEditor;
  setCurrentConfig: React.Dispatch<React.SetStateAction<IProductTemplateTableEditor>>;
};

const ProductTemplateConfig: React.FC<ProductTemplateConfigProps> = ({
  currentConfig,
  setCurrentConfig,
}) => {
  const handleConfigChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | InputNumberValueChangeEvent
      | InputSwitchChangeEvent
      | MultiSelectChangeEvent
  ) => {
    setCurrentConfig(prevState => ({ ...prevState, [e.target.id]: e.target.value }));
  };

  return (
    <div className="w-full flex flex-wrap md:flex-nowrap gap-3 mb-3">
      <div className="w-full md:w-6 gap-2 flex flex-column justify-content-center">
        <label htmlFor="filter">{T("word.hidden-filter")}</label>
        <InputText id="filter" value={currentConfig?.filter ?? ""} onChange={handleConfigChange} />
      </div>
      <div className="w-full md:w-6 gap-2 flex flex-column justify-content-center">
        <label htmlFor="defaultFilter">{T("word.default-filter")}</label>
        <InputText
          id="defaultFilter"
          value={currentConfig?.defaultFilter ?? ""}
          onChange={handleConfigChange}
        />
      </div>
      <div className="w-5 md:w-3 gap-2 flex flex-column justify-content-center align-items-center">
        <label htmlFor="itemsPerPage">{T("component.items-per-page")}</label>
        <InputNumber
          id="itemsPerPage"
          value={currentConfig?.itemsPerPage}
          onValueChange={handleConfigChange}
        />
      </div>
      <div className="w-5 md:w-3 gap-2 flex flex-column justify-content-center align-items-center">
        <label htmlFor="updateFrequency">{T("load-conf.update-frequency")}</label>
        <div className="p-inputgroup">
          <InputNumber
            id="updateFrequency"
            value={currentConfig?.updateFrequency as number}
            onValueChange={handleConfigChange}
          />
          <span className="p-inputgroup-addon">s</span>
        </div>
      </div>
    </div>
  );
};

export default ProductTemplateConfig;
